import { TUI_DEFAULT_HTML5_MEDIA_ATTRIBUTES } from '@taiga-ui/editor/common';
import { tuiParseNodeAttributes, tuiGetNestedNodes } from '@taiga-ui/editor/utils';
import { Node, mergeAttributes } from '@tiptap/core';
const TuiAudio = Node.create({
  name: 'audio',
  group: 'block',
  content: 'source+',
  addAttributes() {
    return tuiParseNodeAttributes(TUI_DEFAULT_HTML5_MEDIA_ATTRIBUTES);
  },
  parseHTML() {
    return [{
      tag: 'audio'
    }];
  },
  renderHTML({
    node,
    HTMLAttributes
  }) {
    return ['audio', HTMLAttributes, ...tuiGetNestedNodes(node)];
  }
});
const TuiSource = Node.create({
  name: 'source',
  addAttributes() {
    return tuiParseNodeAttributes(['src', 'type', 'width', 'height', 'media', 'sizes', 'srcset']);
  },
  parseHTML() {
    return [{
      tag: 'source'
    }];
  },
  renderHTML({
    HTMLAttributes
  }) {
    return ['source', mergeAttributes(HTMLAttributes)];
  }
});
const TuiVideo = Node.create({
  name: 'video',
  group: 'block',
  content: 'source+',
  addAttributes() {
    return tuiParseNodeAttributes(TUI_DEFAULT_HTML5_MEDIA_ATTRIBUTES);
  },
  parseHTML() {
    return [{
      tag: 'video'
    }];
  },
  renderHTML({
    node,
    HTMLAttributes
  }) {
    return ['video', HTMLAttributes, ...tuiGetNestedNodes(node)];
  }
});

/**
 * Generated bundle index. Do not edit.
 */

export { TuiAudio, TuiSource, TuiVideo };
